// extracted by mini-css-extract-plugin
var _1 = "q9NZUlTX0U";
export { _1 as "root" }
